module.exports = __webpack_public_path__ + "img/becomeinstructor.1008fc52.svg";